import { Card, CardBody, Col, Row } from "reactstrap";
import { P } from "../../../AbstractElements";
import { VerticalDottedDividerTitle } from "../../../Constants/Constants";
import { VerticalDottedDividerData, VerticalDottedDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import SvgIcon from "../../CommonComponents/SvgIcon/SvgIcon";

const VerticalDottedDivider = () => {
  return (
    <Col xxl="4" md="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={VerticalDottedDividerTitle} span={VerticalDottedDividerSubTitle} />
        <CardBody className="main-divider">
        <Row className="g-sm-2 d-flex dotted-divider gy-4">
          {VerticalDottedDividerData.map((item, index) => (
            <Col sm="3" xs="6" key={index}>
              <div className="vertical-divider">
                <div className={`vertical-line bg-${item.color}`}></div>
                {item.icon ? <SvgIcon className={`my-2 stroke-icon stroke-${item.color}`} iconId={item.icon} /> : <P className={`my-2 ${item.textClass}-${item.color}`}>{item.text}</P>}
                <div className={`vertical-line bg-${item.color}`}></div>
              </div>
            </Col>
          ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VerticalDottedDivider;
